export default __webpack_public_path__ + "static/media/riskratingBlueIcon.daccbd3e.svg";